import type { DisconnectedChannel } from "@/frontend/hooks/useDashboard";
import { formatPhoneNumberIntl } from "react-phone-number-input";

export function getChannelOutageId(channel: DisconnectedChannel): string {
  return `${channel.type}:${channel.id}:${channel.disconnectedAt}`;
}

export function getChannelHealthDismissalKey(
  organizationId: string,
  userId: string,
): string {
  return `channel-health-dismissed:${organizationId}:${userId}`;
}

function formatPhoneNumber(value: string | null): string | null {
  if (!value) return null;
  const normalized = value.startsWith("+") ? value : `+${value}`;
  return formatPhoneNumberIntl(normalized) || normalized;
}

export function getChannelRecoveryActionLabel(
  channel: DisconnectedChannel,
  belongsToAnotherAdmin = false,
): string {
  if (belongsToAnotherAdmin) return "View connection";
  if (channel.type === "instagram") return "Reauthorize Instagram";
  return `Reconnect ${channel.label}`;
}

export function getDisconnectedChannelAccountLabel(
  channel: DisconnectedChannel,
): string | null {
  if (channel.type === "whatsapp") {
    return formatPhoneNumber(channel.identifier);
  }

  if (channel.type === "waba") {
    return [channel.name, formatPhoneNumber(channel.identifier)]
      .filter(Boolean)
      .join(" · ") || null;
  }

  return channel.name?.startsWith("@") ? channel.name : null;
}
